import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { GenericService } from '../generics/generic.service';
import { SuporteTecnico } from 'src/app/model/geral/suporteTecnico';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SuporteTecnicoService extends GenericService<SuporteTecnico>{

  // URL do serviço de envio de mensagem
  private apiUrl = 'http://localhost:8080/whats/send-message';

  constructor(http: HttpClient) { 
    super(http);
    super.initResource("suporteTecnico")
  }

  // Método para enviar a mensagem
  sendMessage(number: string, message: string): Observable<any> {
    const formData = new FormData();
    formData.append('number', number);  // O número precisa ser passado no formato sem parênteses ou espaços
    formData.append('message', message);  // A mensagem a ser enviada

    return this.http.post(this.apiUrl, formData);
  }

}
